import { z } from "zod";

/**
 * Default extracted-row keys tried as match candidates, in priority order.
 * Workflow authors can replace this list with the field names from their
 * pinned extraction schema.
 */
export const DEFAULT_SUPPLIER_DOCUMENT_MATCH_FIELD_NAMES = [
  "supplierSku",
  "sku",
  "productSku",
  "itemSku",
  "upc",
  "gtin",
  "ean",
  "mpn",
  "supplierDescription",
  "description",
  "productName",
  "name",
] as const;

export const supplierDocumentLineMatchLayerSchema = z.enum([
  "supplier_product",
  "catalog",
  "unmatched",
]);

export const supplierDocumentLineIdentifiersSchema = z.object({
  sku: z.string().nullable(),
  description: z.string().nullable(),
  upc: z.string().nullable(),
  freeform: z.array(z.string()),
});

/**
 * One extracted PDF/email row plus the product match (if any). Shared by the
 * read-only match node and the write-SupplierProduct node so the sockets
 * stay compatible.
 */
export const supplierDocumentLineMatchSchema = z.object({
  index: z.number().int().nonnegative(),
  sourceDocumentId: z.uuid().optional(),
  extracted: z.record(z.string(), z.unknown()),
  identifiers: supplierDocumentLineIdentifiersSchema,
  matchLayer: supplierDocumentLineMatchLayerSchema,
  confidence: z.number().min(0).max(1),
  matchReason: z.string().optional(),
  supplierProductId: z.uuid().nullable(),
  productId: z.uuid().nullable(),
  productVariantId: z.uuid().nullable(),
  productV3Key: z.string().nullable().optional(),
});

export type SupplierDocumentLineMatch = z.infer<
  typeof supplierDocumentLineMatchSchema
>;
export type SupplierDocumentLineMatchLayer = z.infer<
  typeof supplierDocumentLineMatchLayerSchema
>;
